/**
 * Card Helper Utilities
 * Functions for handling card-related logic (Member ID generation, etc.)
 */

/**
 * Generate member ID based on user role and card type
 * @param {string} cardType - Type of card (glic_card, cvs_card, walmart_card, etc.)
 * @returns {string} Generated member ID
 */
export function generateMemberId(cardType = 'glic_card') {
  try {
    const userRole = window.atob(localStorage.getItem('UserRole'));
    const datetime = Math.floor(Math.random() * 1313131);
    
    // CVS and Walmart cards always use dynamic ID
    if (cardType === 'cvs_card' || cardType === 'walmart_card') {
      return `AX${datetime}`;
    }
    
    // Consumer users get static ID, distributors get dynamic
    return userRole === 'consumer' ? '100-4542' : `AX${datetime}`;
  } catch (error) {
    // Fallback to static ID if role cannot be determined
    console.error('Error generating member ID:', error);
    return '100-4542';
  }
}

/**
 * Get card-specific BIN and PCN values
 * @param {string} cardType - Type of card (glic_card, cvs_card, walmart_card, etc.)
 * @returns {object} Object containing bin and pcn values
 */
export function getCardValues(cardType = 'glic_card') {
  const cardValues = {
    'glic_card': { bin: '023518', pcn: 'ARX' },
    'cvs_card': { bin: '610398', pcn: 'CV1' },
    'walmart_card': { bin: '610396', pcn: 'WM1' },
    'citizen_card': { bin: '015284', pcn: 'CRX' },
    'nvt_card': { bin: '610602', pcn: 'NVT' },
    'dst_card': { bin: '600428', pcn: 'HRX' }
  };
  
  return cardValues[cardType] || cardValues['glic_card'];
}
